module.exports = {
      id: "ios-small-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#ios-small",
      toString: function () {
        return this.url;
      }
    }